<template>
  <section class="flex flex-row flex-wrap">
    <scrollable-card />
    <progress-dual-card v-if="false"/>
    <progress-card v-if="false"/>
    <h-progress-card v-if="false"/>
    <donut-card v-if="false"/>
    <v-stack-line-plot-card />
    <line-card />
    <h-bars-plot-card />
    <pie-card v-if="false"/>
    <h-bars-card v-if="false" />
  </section>
</template>

<script>
import ScrollableCard from '@/components/charts/dev/plot/ScrollableCard.vue'
import VStackLinePlotCard from '@/components/charts/dev/plot/VStackLineCard.vue'
import HBarsPlotCard from '@/components/charts/dev/plot/HBarsCard.vue'
import LineCard from '@/components/charts/dev/plot/LineCard.vue'
import DonutCard from '@/components/charts/dev/DonutCard.vue'
import PieCard from '@/components/charts/dev/PieCard.vue'
import HBarsCard from '@/components/charts/dev/HBarsCard.vue'
import HProgressCard from '@/components/charts/dev/HProgressCard.vue'
import ProgressCard from '@/components/charts/dev/ProgressCard.vue'
import ProgressDualCard from '@/components/charts/dev/ProgressDualCard.vue'

export default {
  layout: 'private',
  components: {
    ScrollableCard,
    DonutCard,
    VStackLinePlotCard,
    LineCard,
    HBarsPlotCard,
    PieCard,
    HBarsCard,
    HProgressCard,
    ProgressCard,
    ProgressDualCard
  },
  head () {
    return {
      title: 'Dashboard',
      meta: [{
        requiresAuth: true,
        hid: 'description',
        name: 'description',
        content: 'This is content of Dashboard page'
      }]
    }
  }
}
</script>
